/**
 * Projeta os params da consolidação POR CLIENTE nos params que a rota de GRUPO
 * aceita ao pedir o breakdown por membro.
 *
 * Existe porque as telas de Carteiras montam os filtros no formato do cliente
 * (`buildWalletAnalysisRequest`), enquanto a tela antiga de grupo os montava no
 * formato do grupo (`buildGroupWalletRequest`). Sem esta projeção, os callers
 * novos mandavam SÓ o `id_grupo_familiar` — e sem janela o backend calcula
 * desde a origem do ativo: "Patrimônio por membro" exibiu 1.322.306,76% de
 * rentabilidade onde a tela antiga, com a janela de 12 meses, exibia 27,35%.
 *
 * ★ Quatro chaves ficam de FORA, e cada uma por um motivo diferente:
 *
 * - `id_cliente_app` — o escopo do grupo vai no PATH da rota, e o campo não tem
 *   par no caminho de grupo. Escolher um grupo passou a limpar o cliente do
 *   shell (`client-search.vue::aplicarGrupoComoContexto`), mas a limpeza é do
 *   SELETOR: um deep-link ou uma restauração de sessão pode montar a tela com
 *   grupo e cliente ao mesmo tempo, e aí este campo mandaria um cliente alheio
 *   junto do grupo. O descarte é o que torna isso impossível por construção.
 * - `is_client` — a rota de grupo é de profissional (`permission:
 *   ['profissional']`) e a tela antiga nunca enviou o campo; este é o recorte
 *   medido como correto.
 * - `group_by` — esta carga fixa `group_by=id_cliente`. A classe de API já
 *   ignora o que o caller manda; a projeção evita depender só disso.
 * - `data_requested` — a carga do breakdown pede apenas `["PL","statistics"]`.
 *   O caminho por cliente pede 10 blocos (incluindo `posicao_completa` e
 *   `evolucao_patrimonial`), e repassá-los dobraria o custo do endpoint mais
 *   pesado da tela a cada filtro.
 *
 * @param {Object} args
 * @param {Object} [args.params] Saída de `buildWalletAnalysisRequest`.
 * @returns {Object} Params prontos para `carregarBreakdownPorMembro`.
 */
const CHAVES_DO_CAMINHO_POR_CLIENTE = [
  'id_cliente_app',
  'is_client',
  'group_by',
  'data_requested',
]

export const buildGroupBreakdownRequest = ({ params } = {}) => {
  const source = params && typeof params === 'object' ? params : {}
  const descartadas = new Set(CHAVES_DO_CAMINHO_POR_CLIENTE)
  const projetados = {}

  for (const [chave, valor] of Object.entries(source)) {
    if (descartadas.has(chave)) continue
    projetados[chave] = valor
  }

  return projetados
}
